// extracted by mini-css-extract-plugin
export default {"formHeader":"_dcbb726e","formCopy":"_aa9494d4"};